// extracted by mini-css-extract-plugin
export default {"navLabel":"navLabel___hZ6rn","strong":"strong___wt0qR","large":"large___JVcFH","small":"small___DLaDt","noPadding":"noPadding___YtUHt"};